// extracted by mini-css-extract-plugin
export default {"NoLabels":"WidgetLabels_NoLabels__hFm9H"};